import { render, staticRenderFns } from "./report-output.vue?vue&type=template&id=2bd96db1&scoped=true&"
import script from "./report-output.vue?vue&type=script&lang=js&"
export * from "./report-output.vue?vue&type=script&lang=js&"
import style0 from "./report-output.vue?vue&type=style&index=0&id=2bd96db1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd96db1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VBtn,VCol,VContainer,VRow,VSubheader})
